// Client de `GET /backoffice/sellers/table` (retail-wizard-business).
import { apiFetch } from '../../../client';
import type { SellersTableApi, SellersTableResponse } from './sellersTableContract';

const BASE_URL = import.meta.env.VITE_API_RETAIL_WIZARD_BASE_URL;

export const sellersTableClient: SellersTableApi = {
    getTable: ({ from, to }) => {
        const params = new URLSearchParams({ from, to });
        return apiFetch<SellersTableResponse>(`/backoffice/sellers/table?${params.toString()}`, {
            baseUrl: BASE_URL,
        });
    },
};
